import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { Product, TranslatePipe, UrlPipe } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { ManualsPayload, ManualsService } from 'src/app/service/manuals/manuals.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { GenericLinkComponent } from '../../generic-link/generic-link.component';

@Component({
  selector: 'app-product-size-chart',
  templateUrl: './product-size-chart.component.html',
  styleUrls: ['./product-size-chart.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, MatIcon, GenericLinkComponent, AsyncPipe, TranslatePipe, UrlPipe],
})
export class ProductSizeChartComponent implements OnInit, OnDestroy {
  businessType: string = this.currentBusinesstype.getBusinessType();
  isDiscontinuedSubscrption: Subscription;

  private getProductManuals(code: string): Observable<any> {
    const manualsServicepayload: ManualsPayload = {
      fields: 'DEFAULT',
      productCode: code,
      productOptions: 'MANUALS',
    };
    return this.manualsService.getManuals(manualsServicepayload);
  }

  items$: Observable<any> = this.currentProductService.getProduct().pipe(
    filter(Boolean),
    distinctUntilChanged(),
    switchMap((product: Product) => {
      return this.getProductManuals(product.code).pipe(
        tap((data: any) => {
          if (data.explodedViewList || data.sizeChart) {
            this.componentService.setHasEvLinks(true);
          }
        })
      );
    })
  );

  constructor(
    protected componentService: ComponentService,
    protected currentProductService: CurrentProductService,
    private cdr: ChangeDetectorRef,
    private manualsService: ManualsService,
    private currentBusinesstype: CurrentBusinessType
  ) {}

  ngOnInit(): void {
    this.isDiscontinuedSubscrption = this.componentService.isDiscontinued$.subscribe((isDiscontinued) => {
      const productLinks = document.querySelector('.ProductDescription app-product-size-chart');
      isDiscontinued ? productLinks.classList.add('hide-link') : productLinks.classList.remove('hide-link');
    });
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.isDiscontinuedSubscrption?.unsubscribe();
  }
}
